import api from "../../Http/global-vars";
import { ANNUAL_REPORT } from "../types";

export const fetchAnnualReports = () => {
  return async (dispatch) => {
    const url = api + "annual_reports/";
    await fetch(url)
      .then(async (res) => {
        const data = await res.json();
        dispatch({
          type: ANNUAL_REPORT,
          payload: data,
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
